export default __webpack_public_path__ + "static/media/My Img.49d157c0.jpg";